import React from 'react'
import {
  Box,
  Typography,
  Button,
  Stack,
  useTheme,
  IconButton,
} from '@mui/material'
import { Close } from '@mui/icons-material'

/**
 * Кастомный компонент для всплывающих окон react-joyride.
 */
const TourTooltip = ({
  index,
  size,
  step,
  backProps,
  closeProps,
  skipProps,
  primaryProps,
  tooltipProps,
  isLastStep,
}) => {
  const theme = useTheme()

  return (
    <Box
      {...tooltipProps}
      sx={{
        position: 'relative', // Необходимо для позиционирования кнопки закрытия
        // Устанавливаем стандартный непрозрачный фон для читаемости
        backgroundColor: 'background.paper',
        borderRadius: 3,
        boxShadow: theme.shadows[8],
        maxWidth: 350,
        p: 2.5,
        // Анимация появления
        '@keyframes fadeIn': {
          from: { opacity: 0, transform: 'translateY(10px)' },
          to: { opacity: 1, transform: 'translateY(0)' },
        },
        animation: 'fadeIn 0.3s ease-out',
      }}
    >
      <IconButton
        {...closeProps}
        aria-label="close"
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
        }}
      >
        <Close />
      </IconButton>
      <Stack spacing={1}>
        {step.title && (
          <Typography
            variant="h6"
            component="div"
            sx={{
              mb: 1,
              fontWeight: 'bold',
              background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            {step.title}
          </Typography>
        )}
        <Typography
          variant="body2"
          // Устанавливаем основной цвет текста, чтобы он не был полупрозрачным
          color="text.primary"
          sx={{ lineHeight: 1.6 }}
        >
          {step.content}
        </Typography>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mt: 2 }}
        >
          {!isLastStep ? (
            <Button {...skipProps} size="small">
              {step.locale.skip}
            </Button>
          ) : (
            <Box /> // Пустой бокс для сохранения выравнивания
          )}
          <Stack direction="row" spacing={1}>
            {index > 0 && (
              <Button {...backProps} size="small">
                {step.locale.back}
              </Button>
            )}
            <Button {...primaryProps} variant="contained" size="small">
              {isLastStep ? step.locale.last : step.locale.next}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  )
}

export default TourTooltip
